export default {
  'error.request.error': '请求错误',
  'error.response.error': '响应状态码：',
  'error.noResponse': '未收到服务器响应，请重试',
  'error.requestFailed': '请求发送失败，请重试',
  'error.processingFailed': '请求处理失败',
};
